const ONLY_RATING_MODE = 'only_rating'
const RATING_AND_COMMENT_MODE = 'rating_and_comment'

export default {
  ONLY_RATING_MODE,
  RATING_AND_COMMENT_MODE,
}
